/* eslint-disable no-undef */

var Model = require("../types/Model.js");

var Promise = require("promise");
// eslint-disable-next-line node/no-missing-require
var ReactNative = require("react-native");
var RNImage = ReactNative.Image;
var Platform = ReactNative.Platform;
var global = require("global");
var exif = require("image-uri-exif-orientation");

var par = require("par");

module.exports = Model({
	name: "personalprofilepicture",
	init: init,
	triggers: triggers,

	_image: null,
	_orientation: null,

	reset: reset,
});

function init() {
	this.reset();
}

function triggers() {
	return {
		"start": start_updating,
		"crop": crop_and_upload,
		"cancel": cancel_updating
	};
}

function reset() {
	this._image = null;
	this._orientation = null;

	this.push({
		image: null,
		width: 0,
		height: 0,
		orientation: null,
	});
}

function start_updating(data) {
	var image = data.image;
	this._image = image;

	this.emit("save:trigger:start");
	this.emit("usermetrics:trigger:track", "begin cropping own new profile picture");
	if (image.isCordova || image.isNative)
		return loadImageSize(image)
			.then(handle_got_size.bind(this))
			.catch(handle_error.bind(this))
			.then(finish_save.bind(this));

	return loadImageSize(image)
		.then(handle_got_size.bind(this))
		.then(par(getImageOrientation, image))
		.then(handle_got_orientation.bind(this))
		.catch(handle_error.bind(this))
		.then(finish_save.bind(this));
}

function finish_save() {
	this.emit("save:trigger:finish");
}

function loadImageSize(image) {
	if (!isWeb()) return getSized(image);
	return loadFileWeb(image).then(compressImage).then(par(base4ToFile, image.name)).then(loadFileWeb).then(getSized);
}

function loadFileWeb(image) {
	return new Promise(function (resolve, reject) {
		if (image.isCordova) {
			return resolve({
				uri: image.url
			});
		}
		var FileReader = global.FileReader;
		var reader = new FileReader();
		reader.onload = function () {
			var result = reader.result;
			resolve({
				uri: result
			});
		}.bind(this);
		reader.readAsDataURL(image);
		reader.onerror = reject;
	});
}

function getSized(image) {
	var uri = image.uri;

	return new Promise(function (resolve, reject) {
		RNImage.getSize(uri, function (width, height) {
			resolve({
				image: image,
				width: width,
				height: height
			});
		}, reject);
	});
}

function isWeb() {
	return Platform.OS === "web";
}

function handle_got_size(size) {
	this.extend(size);
	this.dispatch("started");
}

function handle_got_orientation(orientation) {
	this._orientation = orientation;
	this.extend(orientation);
}

function handle_error(e) {
	this.emit("save:trigger:finish");
	console.error(e);

	var message = "profilepicturechoose.uploadfails";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function crop_and_upload(data) {
	var crop = data.crop;
	var orientation = 0;
	if (this._orientation)
		orientation = this._orientation.orientation;
	var rotateMap = {
		"-2": 0,
		"-1": 0,
		"0": 0,
		"1": 0,
		"2": 0,
		"3": 180,
		"4": 0,
		"5": 0,
		"6": 90,
		"7": 0,
		"8": 270
	};

	var image = isWeb() ? this._image : this.data.image;

	if (data.image)
		image = data.image;

	this.emit("save:trigger:start");

	var rotation = image.isNative ? image.originalRotation : rotateMap[orientation];

	this.api.people.picture(image, {
		crop: crop,
		rotate: rotation || 0
	})
		.then(handle_uploaded.bind(this))
		.catch(handle_error.bind(this));

	this.emit("usermetrics:trigger:track", "crop and upload new own profile picture");
}

function handle_uploaded() {
	this.emit("save:trigger:finish");

	var message = "profilepicturechoose.uploadsuccess";
	this.emit("toast:trigger:show", {
		content: message,
	});

	this.dispatch("success");
	this.reset();
}

function cancel_updating() {
	this.dispatch("cancelled");
	this.reset();
	this.emit("usermetrics:trigger:track", "cancel crop own new profile picture");
}


function getImageOrientation(image) {
	if (!isWeb()) return getOrientation(image);
	return loadFileWeb(image).then(getOrientation);
}

function getOrientation(image) {
	return exif(image.uri).then(function (orientation) {
		return {
			orientation: orientation
		};
	});
}


function compressImage(base64Img) {
	return new Promise(function (resolve, reject) {
		const image = new Image();
		image.src = base64Img.uri;
		let canvas = document.getElementById("compressCanvas");

		if (!canvas) {
			const body = document.body;
			canvas = document.createElement("canvas");

			canvas.id = "compressCanvas";
			canvas.style.position = "fixed";
			canvas.style.zIndex = "-1";
			canvas.style.opacity = "-1";
			canvas.style.top = "-100%";
			canvas.style.left = "-100%";
			body.append(canvas);
		}
		const context = canvas.getContext("2d");

		RNImage.getSize(base64Img.uri, function (width, height) {
			const ratio = Math.min(width / 400, height / 400);
			const newHeight = Math.min(Math.floor(height / ratio), height);
			const newWidth = Math.min(Math.floor(width / ratio), width);

			canvas.height = newHeight;
			canvas.width = newWidth;

			context.drawImage(image, 0, 0, newWidth, newHeight);
			const compressBase64 = canvas.toDataURL("image/jpeg", "0.7");
			resolve(compressBase64);
		}, reject);
	});
}

function base4ToFile(fileName, base64Image) {
	const arr = base64Image.split(",");
	const mime = arr[0].match(/:(.*?);/)[1];
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	fileName = fileName || ("file-" + Date.now() + ".jpg");
	return new File([u8arr], fileName, { type: mime });
}
